import React from 'react'
import { Redirect } from 'react-router';

//import firebase from '../FirebaseConfig.js'
import analyticsHelper from '../AnalyticsHelper.js'

import HTHeader from './HTHeader.js'
import HTFooter  from './HTFooter.js'
import HTSearchBar from './HTSearchBar'
import HTPillTag from './HTPillTag'
import HTContentListRow from './HTContentListRow.js'
import HTFullContent from './HTFullContent'

import lessonsArray from '../content/lessons.js'
import faqsArray from '../content/faqs.js'

const contentArray = lessonsArray.concat(faqsArray)

let content = {}
lessonsArray.map(one => {
    content[one.url] = one
})
faqsArray.map(oneFaq => {
  content[oneFaq.uid] = oneFaq
})

class HTLanding extends React.Component {

  constructor (props) {
    super(props)
    this.onSearch = this.onSearch.bind(this)
    this.buildTags = this.buildTags.bind(this)
    this.state = {searchKey: ""}
  }

  onSearch (searchText) {
    // redirect to /search?key=searchText
    this.setState({searchKey: searchText})
    analyticsHelper.genEvent(analyticsHelper.EVENT_SEARCH, analyticsHelper.SEARCH_LANDING, searchText)
    //firebase.analytics().logEvent('search_from_landing with: '+searchText);
  }

  buildTags () {

    // create the list as a object initially, to prevent duplicates
    let that = this
    let pills = {}
    contentArray.map(function (content,contentIndex) {
      content.tags.map(function (tag,tagIndex) {
        pills[tag] = <HTPillTag title={tag} onClick={(tag) => that.onSearch(tag)} key={"tag_"+contentIndex+tagIndex} />
      })
    })

    // convert object to array so you can use it as jsx child
    let pillsArray = Object.values(pills)

    return (
      <div id="pill-container">
        {pillsArray}
      </div>
    )
  }

  render () {

    if (this.state.searchKey != "") {
      return (<Redirect to={"search?key="+this.state.searchKey} push={true} />)
    }

    return (
      <main>
        <HTHeader HTTitle="Home Theory" onPath="/"/>
        <div id="landing_search_container">
          <HTSearchBar onSearch={this.onSearch} />
        </div>
        {this.buildTags()}
        <HTFooter />
      </main>

    )
  }
}

/*
handleClick={that.selectContent}

{one != null ? <HTFullContent content={one} changeRoute={this.props.changeRoute} /> : this.buildList(this)}

<HTLanding changeRoute={this.setRoute} route={this.state.URLRoute}/>*/

export default HTLanding



// WEBPACK FOOTER //
// src/components/HTLandingPage.js